var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicineLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8999 34.7C68.8999 53.5881 53.5881 68.8999 34.7 68.8999C15.8118 68.8999 0.5 53.5881 0.5 34.7C0.5 15.8118 15.8118 0.5 34.7 0.5C53.5881 0.5 68.8999 15.8118 68.8999 34.7Z",
    fill: "#053A7A",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 17,
    width: 33,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1666 26.6667H22.8333C21.6252 26.6667 20.6458 27.6461 20.6458 28.8542V43.4376C20.6458 44.6457 21.6252 45.6251 22.8333 45.6251H46.1666C47.3748 45.6251 48.3541 44.6457 48.3541 43.4376V28.8542C48.3541 27.6461 47.3748 26.6667 46.1666 26.6667Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.015 20.6934C38.9075 20.5859 38.7821 20.5004 38.6458 20.4397V18.4567C39.2948 18.5612 39.8995 18.8674 40.3703 19.3381C40.841 19.8089 41.1472 20.4135 41.2517 21.0626H39.2687C39.208 20.9263 39.1225 20.8009 39.015 20.6934ZM39.375 22.0626H41.2916V26.1667H39.375V22.0626ZM37.6458 20.3334H31.3541V18.4167H37.6458V20.3334ZM29.985 20.6934C29.8775 20.8009 29.7919 20.9263 29.7313 21.0626H27.7483C27.8528 20.4135 28.1589 19.8089 28.6297 19.3381C29.1005 18.8674 29.7051 18.5612 30.3541 18.4567V20.4397C30.2179 20.5004 30.0925 20.5859 29.985 20.6934ZM29.625 22.0626V26.1667H27.7083V22.0626H29.625Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 36.146H38.875M34.5 31.771V40.521",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 15H52V50H17V15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineLogo);
export default __webpack_public_path__ + "static/media/medicine-logo.c80fe0f1b4085e2573c29b9d76449c38.svg";
export { ForwardRef as ReactComponent };